export const TASKBAR_HEIGHT = 44;
/** Height of the global TopBar — kept here so layout code can subtract it
 *  without importing the TopBar component. Must match TOP_BAR_HEIGHT in
 *  components/topbar/TopBar.tsx. */
export const TOPBAR_HEIGHT_PX = 36;
